import { render } from "./AgreementView.vue?vue&type=template&id=fe6b5186"
import script from "./AgreementView.vue?vue&type=script&lang=js"
export * from "./AgreementView.vue?vue&type=script&lang=js"

import "./AgreementView.vue?vue&type=style&index=0&id=fe6b5186&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__